import _ from 'lodash'
import moment from 'moment'
import { api } from "../api/apiCore";

export function updateCompanyProfile(data) {
	let url
	const profilePath = data.profile_id ? `/profiles/${data.profile_id}` : '/profiles'
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}${profilePath}`
			break
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}${profilePath}`
			break
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}${profilePath}`
			break
		case 'fleet_manager':
		case 'storage_manager':
		case 'custom_user':
			url = profilePath
			break
	}
	const form = new FormData()
	data.name && !data.profile_id ? form.append('name', data.name) : ''
	data.configuration ? form.append('configuration', data.configuration) : ''
	data.device_type && !data.profile_id ? form.append('device_type', data.device_type) : ''
	data.configurationdv6 ? form.append('configurationdv6', data.configurationdv6) : ''
	data.configurationdv7 ? form.append('configurationdv7', data.configurationdv7) : ''

	if (data.event_types) {
		_.forOwn(data.event_types, (value, key) => {
			form.append(key, value)
		})
	}
	_.has(data, 'advanced_quality_channels') ? form.append('advanced_quality_channels', data.advanced_quality_channels) : ''

	return api.postForm(url, form);
}

export function deleteCompanyProfile (data) {
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/profiles/${data.profile_id}`
			break
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/profiles/${data.profile_id}`
			break
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/profiles/${data.profile_id}`
			break
		case 'fleet_manager':
		case 'storage_manager':
		case 'custom_user':
			url = `/profiles/${data.profile_id}`
			break
	}

	const form = new FormData()
	if (data.preferred_profile_id) {
		form.append('preferred_profile_id', data.preferred_profile_id)
	}

	return api.delete(url, { data: form });
}

export function getCompanyProfiles(data) {
	let url
	switch (data.user_role) {
	case 'system_admin':
		url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/profiles`
		break
	case 'customer_service':
		url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/profiles`
		break
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${data.company_name}/profiles`
		break
	case 'sales_demo':
		url = `/sales_demo/partner/${data.partner_name}/companies/${data.company_name}/profiles`
		break
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'storage_manager':
	case 'custom_user':
	case 'group_manager':
	case 'user':
		url = `/profiles`
		break
	default:
		break
	}

	if (data.include_data) {
		url += '?include_data='+data.include_data
	}

	return api.get(url)
}

export function getProfileUpdateStates(data) {
	const url = `/profiles/${data.profileId}/states`;

	return api.get(url)
}

export function getProfileUpdateData(data) {
	const url = `/profiles/${data.profileId}/states/devices?page_number=1&page_size=100`;

	return api.get(url)
}

export function sendGeotabLink(data) {
	const url = `/company/geotab/email`
	const form = new FormData()
	form.append('email', data.geotab_email)
	form.append('company_name', data.company_name)
	form.append('partner_name', data.partner_name)
	form.append('provision_link', data.provision_link)
	if (data.accountKey) {
		form.append('accountKey', data.accountKey)
	}

	return api.putForm(url, form);
}

export function deleteCompany (data) {
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'storage_manager':
			url = `/companies/${data.company_name}`;
			break;
	}

	return api.delete(url);
}

export function getCompaniesList(user_role, company_type, get_type) {
	let url;
	switch(user_role) {
		case 'system_admin':
			url = `/system_admin/companies/filter/list?company_type=${company_type}`; //get partners
			break;
		case 'customer_service':
			url = `/customer_service/companies/filter/list?company_type=${company_type}`; //get partners
			break;
		case 'partner':
		case 'partner_view':
		case 'custom_partner':
			url = `/partners/companies/filter/list?company_type=${company_type}`;
			break;
		case 'installer':
			url = `/installer/companies/filter/list?company_type=${company_type}`;
			break;
		case 'sales_demo':
			url = `/sales_demo/companies/filter/list?company_type=${company_type}`;
			break;
	}

	if (get_type) {
		url +='&gettype=true'
	}

	return api.get(url)
}

export function getPartnerCompaniesList(user_role, partner_company_name, get_type) {
	let url;
	switch(user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${partner_company_name}/companies/filter/list`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${partner_company_name}/companies/filter/list`;
			break;
		case 'installer':
			url = `/installer/companies/filter/list`;
			break;
		case 'sales_demo':
			url = `/sales_demo/partner/${partner_company_name}/companies/filter/list`;
			break;
	}

	if (get_type) {
		url +='?gettype=true'
	}

	return api.get(url)
}

export function getAllCompanies(user_role, company_type) {
	let url;
	switch(user_role) {
		case 'system_admin':
			url = `/system_admin/companies?type=${company_type}`;
			break;
		case 'customer_service':
			url = `/customer_service/companies?type=${company_type}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies`;
			break;
		case 'sales_demo':
			url = `/sales_demo/companies?type=${company_type}`;
			break;
	}

	return api.get(url)
}

export function getCompaniesCustomer() {
	const url = `/customer_service/companies`;

	return api.get(url)
}


export function getCompanyByName(user_role, company_name=null, partner_name=null, dms_cutoff=null) {
	let url;
	switch(user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${partner_name}/companies/${company_name}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${partner_name}/companies/${company_name}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${company_name}`;
			break;
		case 'partner_view':
			url = `/partner_view/companies/${company_name}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'user':
		case 'storage_manager':
		case 'storage_user':
		case 'custom_user':
			url = `/company`;
			break;
	}

	if (dms_cutoff) {
		url += '?include_data=dms_notifs_cutoff'
	}

	return api.get(url)
}

export function getCompanyById(userRole, companyId, include_data) {
	let url;
	switch (userRole) {
		case 'system_admin':
			url = `/system_admin/companies/${companyId}`;
			break;
		case 'customer_service':
			url = `/customer_service/companies/${companyId}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${companyId}`;
			break;
		case 'sales_demo':
			url = `/sales_demo/companies/${companyId}`;
			break;
		default:
			url = `/company/${companyId}`;
			break;
	}

	if (include_data) {
		url += '?include_data=' + include_data
	}

	return api.get(url)
}

export function updateCompany(state, user_role, callback) {
	let url;
	switch (user_role) {
	case 'fleet_manager':
	case 'storage_manager':
		url = `/company`;
		break;
	case 'system_admin':
		url = `/system_admin/partner/${state.company.owner_company}/companies/${state.company.company_name}`;
		break;
	case 'customer_service':
		url = `/customer_service/partner/${state.company.owner_company}/companies/${state.company.company_name}`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${state.company.company_name}`;
		break;
	default:
		break;
	}

	const form = new FormData();
	state.data.company_city ? form.append('company_city', state.data.company_city) : '';
	(_.has(state.data, 'company_state') || state.data.company_state) ? form.append('company_state', state.data.company_state) : '';
	state.data.company_zipcode ? form.append('company_zipcode', state.data.company_zipcode) : '';
	state.data.company_address ? form.append('company_address', state.data.company_address) : '';
	_.has(state.data, 'company_address2') ? form.append('company_address2', _.get(state, 'data.company_address2', '')) : '';
	state.data.company_country ? form.append('company_country', state.data.company_country) : '';
	(_.has(state.data, 'company_phone_number') || !_.isEmpty(state.data.company_phone_number)) ? form.append('company_phone_number', state.data.company_phone_number) : '';
	state.data.billing_date ? form.append('billing_date', state.data.billing_date) : '';
	state.data.company_name ? form.append('company_new_name', state.data.company_name) : '';
	state.data.company_type ? form.append('company_type', state.data.company_type) : '';
	state.data.partner_company ? form.append('partner_company', state.data.partner_company) : '';
	state.data.data_limit ? form.append('data_limit', state.data.data_limit) : '';

	_.has(state.data, 'storage_active') ? form.append('storage_active', state.data.storage_active) : '';
	_.has(state.data, 'trace_active') ? form.append('trace_active', state.data.trace_active) : '';
	_.has(state.data, 'live_active') ? form.append('live_active', state.data.live_active) : '';
	_.has(state.data, 'download_files') ? form.append('download_files', state.data.download_files) : '';
	_.has(state.data, 'file_retention_time') ? form.append('file_retention_time', state.data.file_retention_time) : '';
	_.has(state.data, 'driver_recognition') ? form.append('driver_recognition', state.data.driver_recognition) : ''
	_.has(state.data, 'timezone') ? form.append('timezone', state.data.timezone) : ''
	_.has(state.data, 'reformat_reminder') ? form.append('reformat_reminder', state.data.reformat_reminder) : ''
	_.has(state.data, 'dms_notifs_cutoff') ? form.append('dms_notifs_cutoff', state.data.dms_notifs_cutoff) : ''
	_.has(state.data, 'advanced_profile_settings') ? form.append('advanced_profile_settings', state.data.advanced_profile_settings) : ''
	_.has(state.data, 'asset_deletion_protection') ? form.append('asset_deletion_protection', state.data.asset_deletion_protection) : ''
	_.has(state.data, 'event_expiration') ? form.append('event_expiration', state.data.event_expiration) : ''
	_.has(state.data, 'custom_apn') ? form.append('custom_apn', state.data.custom_apn) : ''
	// _.has(state.data, 'data_threshold_pct') ? form.append('data_threshold_pct', state.data.data_threshold_pct) : ''
	// _.has(state.data, 'data_threshold_type') ? form.append('data_threshold_type', state.data.data_threshold_type) : ''
	_.has(state.data, 'industry_type') ? form.append('industry_type',state.data.industry_type) : ''
	_.has(state.data, 'using_rosco_sim') ? form.append('using_rosco_sim',state.data.using_rosco_sim) : ''
	_.has(state.data, 'override_overage_limits') ? form.append('override_overage_limits',state.data.override_overage_limits) : ''
	_.has(state.data, 'speedlimit_feature') ? form.append('speedlimit_feature', state.data.speedlimit_feature) : ''
	_.has(state.data, 'speedlimit_audio') ? form.append('speedlimit_audio', state.data.speedlimit_audio) : ''
	_.has(state.data, 'geofencing_active') ? form.append('geofencing_active', state.data.geofencing_active) : ''

	if (_.has(state.data, 'bewhere_account_id')) {
		form.append('bewhere_account_id', state.data.bewhere_account_id || null)
	}

	if (_.has(state.data, 'trial_status')) {
		form.append('trial_status', state.data.trial_status)
		state.data.trial_status ? form.append('trial_date', moment(state.data.trial_date).format('YYYYMMDD000000')) : form.append('trial_date', '')
		state.data.trial_status ? form.append('trial_subscribers', state.data.trial_subscribers) : form.append('trial_subscribers', '')
	}

	if (state.data.fleet_configuration) {
		let fleet_configuration = state.data.fleet_configuration;
		if (typeof fleet_configuration === 'object') {
			fleet_configuration = JSON.stringify(fleet_configuration);
		}
		form.append('fleet_configuration', fleet_configuration);
	}

	return api.postForm(url, form);
}

export function disableCompany(user_role, state, active) {
	let url;
	switch(user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${state.company.owner_company}/companies/${state.company.company_name}/${active}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${state.company.owner_company}/companies/${state.company.company_name}/${active}`;
			break;
	}

	return api.postForm(url);
}

export function createCompanyCustomer(state, user_role, partner_name) {
	let url;
	switch(user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${partner_name}/companies/${state.data.company_name}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${partner_name}/companies/${state.data.company_name}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${state.data.company_name}`;
			break;
	}

	const form = new FormData();
	form.append('company_city', state.data.company_city);
	form.append('company_state', state.data.company_state);
	form.append('company_zipcode', state.data.company_zipcode);
	form.append('company_address', state.data.company_address);
	(state.data.company_address2 && !_.isEmpty(state.data.company_address2) ) ? form.append('company_address2', state.data.company_address2) : '';

	form.append('company_country', state.data.company_country);
	form.append('company_phone_number', _.get(state, 'data.company_phone_number', ''));

	form.append('live_active', state.data.live_active);
	form.append('billing_date', state.data.billing_date);
	form.append('cutoff_when_overage', state.data.cutoff_when_overage);
	form.append('storage_active', state.data.storage_active);
	form.append('trace_active', state.data.trace_active);
	form.append('industry_type', state.data.industry_type);
	state.data.assigned_fleet_token ? form.append('assigned_fleet_token', state.data.assigned_fleet_token) : '';
	state.data.company_type !=='' ? form.append('company_type', state.data.company_type) : '';
	state.data.partner_company ? form.append('partner_company', state.data.partner_company) : '';
	state.data.data_limit ? form.append('data_limit', state.data.data_limit) : '';

	state.data.download_files ? form.append('download_files', state.data.download_files) : '';
	state.data.file_retention_time ? form.append('file_retention_time', state.data.file_retention_time) : '';
	_.has(state.data, 'custom_apn') ? form.append('custom_apn', state.data.custom_apn) : ''

	if (_.has(state.data, 'trial_status')) {
		form.append('trial_status', state.data.trial_status)
		state.data.trial_status ? form.append('trial_date', moment(state.data.trial_date).format('YYYYMMDD000000')) : form.append('trial_date', '')
	}

	return api.putForm(url, form);
}

export function disablePartner(user_role, state, active) {
	let url;
	switch(user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${state.company_name}/${active}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${state.company_name}/${active}`;
			break;
	}

	return api.postForm(url);
}

export function createPartner(state, user_role) {
	let url;
	switch(user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${state.data.company_name}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${state.data.company_name}`;
			break;
	}

	const form = new FormData();
	form.append('company_city', state.data.company_city);
	form.append('company_state', state.data.company_state);
	form.append('company_zipcode', state.data.company_zipcode);
	form.append('company_address', state.data.company_address);
	form.append('company_country', state.data.company_country);
	(state.data.company_address2 && !_.isEmpty(state.data.company_address2)) ? form.append('company_address2', state.data.company_address2) : '';
	(state.data.company_phone_number && !_.isEmpty(state.data.company_phone_number)) ? form.append('company_phone_number', state.data.company_phone_number) : '';

	return api.putForm(url, form);
}

export function updatePartner(state, user_role, callback) {
	let url
	switch(user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${state.company.company_name}`
			break
		case 'customer_service':
			url = `/customer_service/partner/${state.company.company_name}`
			break
	}

	const form = new FormData();
	state.data.company_city ? form.append('company_city', state.data.company_city) : '';
	state.data.company_state ? form.append('company_state', state.data.company_state) : '';
	state.data.company_zipcode ? form.append('company_zipcode', state.data.company_zipcode) : '';
	state.data.company_address ? form.append('company_address', state.data.company_address) : '';
	state.data.company_country ? form.append('company_country', state.data.company_country) : '';

	(state.data.company_address2 || _.isEmpty(state.data.company_address2)) ? form.append('company_address2', state.data.company_address2) : '';
	(state.data.company_phone_number || !_.isEmpty(state.data.company_phone_number)) ? form.append('company_phone_number', state.data.company_phone_number) : '';

	state.data.billing_date ? form.append('billing_date', state.data.billing_date) : '';
	state.data.company_name ? form.append('company_new_name', state.data.company_name) : '';

	form.append('storage_active', state.data.storage_active)
	form.append('trace_active', state.data.trace_active)
	form.append('live_active', state.data.live_active)
	form.append('allow_create_company', state.data.allow_create_company)
	form.append('allow_edit_company', state.data.allow_edit_company)

	return api.postForm(url, form);
}

export function deletePartner (data) {
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}`;
			break;
	}

	return api.delete(url);
}

export function getCompanyZones(companyId, params) {
	const queryParams = new URLSearchParams(params).toString();
	const url = `/companies/${companyId}/zones?${queryParams}`;

	return api.get(url)
}

export function createZone(companyId, data) {
	const url = `/companies/${companyId}/zones`;

	const form = new FormData();

	for (const key in data) {
		if (key === 'shape_points') {
			form.append(key, JSON.stringify(data[key]));
		} else {
			form.append(key, data[key]);
		}
	}

	return api.putForm(url, form);
}

export function editZone(companyId, zoneId, data) {
	const url = `/companies/${companyId}/zones/${zoneId}`;

	const form = new FormData()

	for (const key in data) {
		if (key === 'shape_points') {
			form.append(key, JSON.stringify(data[key]));
		} else {
			form.append(key, data[key]);
		}
	}

	return api.postForm(url, form);
}

export function deleteZone(companyId, zoneId) {
	const url = `/companies/${companyId}/zones/${zoneId}`;

	return api.delete(url);
}

export function addCompanyToBlackList(data) {
	const url = `/companies/firmware/blacklist`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.putForm(url, form);
}

export function removeCompanyFromBlackList(data) {
	const url = `/companies/firmware/blacklist`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.delete(url, {
		data: form
	});
}

export function getFirmwareBlacklist(data) {
	const url = `/companies/firmware/blacklist`;

	return api.get(url);
}

export function uploadVehicles(data) {
	const url = `/companies/${data.company_id}/devices/file`;

	const form = new FormData();
	form.append('file', data.file);

	return api.putForm(url, form);
}

export function sendExternalTypeLink(data) {
	const { server_type, ...rest } = data;
	const url = `/external_service/${server_type}/provision_link/email`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form);
}

export function savePartnerWhitelabel(data) {
	const { partner_id, ...rest } = data;
	const url = `/partner/${partner_id}/settings`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form);
}

export function getPartnerWhitelabel(data) {
	const { company_id, ...rest } = data;
	const url = `/partner/${company_id}/settings`;

	return api.get(url);
}

export function getPartnerSettings() {
	const url = `/partner/settings`;

	return api.get(url);
}

export function getCompanyDrivers(data) {
	const { companyId, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/company/${companyId}/driver${params}`;

	return api.get(url);
}

export function getCompanyDriverTrip(data) {
	const { company_id, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/company/{company_id}/driver/trip${params}`;

	return api.get(url);
}

export function getCompanyCameraHealthError(data) {
	const { company_id, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/companies/${company_id}/camera_health_error${params}`;

	return api.get(url);
}

export function getCompanyRouters(data) {
	const { companyId, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/company/${companyId}/router${params}`;

	return api.get(url);
}
export function getCompany(data) {
	const { company_id } = data;

	const url = `/company/${company_id}`;

	return api.get(url);
}

export function getDriverTripsPhotos(data) {
	const { companyId, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/company/${companyId}/driver_trips_photos${params}`;

	return api.get(url);
}

export function getDataTrackingReport(data) {
	const { companyId, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/companies/${companyId}/reports/data_tracking${params}`;

	return api.get(url);
}

export function getUnknownDriversTrip(data) {
	const { companyId, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/company/${companyId}/unknown_drivers/trip${params}`;

	return api.get(url);
}

export function getCustomProfiles(data) {
	const { company_id } = data;

	const url = `/companies/${company_id}/custom_user_profile`;

	return api.get(url);
}

export function saveCustomProfiles(data) {
	const url = `/companies/${data.company_id}/custom_user_profile`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.putForm(url, form);
}
